// color design tokens export
export const tokensDark = {
  grey: {
    0: "#ffffff", // white for light elements
    10: "#f6f6f6",
    50: "#f0f0f0",
    100: "#e0e0e0",
    200: "#c2c2c2",
    300: "#a3a3a3",
    400: "#858585",
    500: "#666666",
    600: "#525252",
    700: "#3d3d3d",
    800: "#292929", // sidebar background
    900: "#141414",
    1000: "#000000", // pure black
  },
  primary: {
    // Removed blue tones
    100: "#cbd1ea", // Placeholder, adjust if needed
    200: "#9ca3d6",
    300: "#6e76c2",
    400: "#4049ad",
    500: "#121d99",
    600: "#101780",
    700: "#0d1267",
    800: "#0a0e4d",
    900: "#070a34",
  },
  secondary: {
    // Adjusted secondary colors (yellow)
    50: "#fff4db", // light yellow
    100: "#ffebb6",
    200: "#ffe190",
    300: "#ffd76a",
    400: "#ffcd44",
    500: "#ffc31e", // main highlight color
    600: "#cc9c18",
    700: "#997513",
    800: "#664e0e",
    900: "#332707",
  },
}

// function that reverses the color palette
function reverseTokens(tokensDark) {
  const reversedTokens = {}
  Object.entries(tokensDark).forEach(([key, val]) => {
    const keys = Object.keys(val)
    const values = Object.values(val)
    const length = keys.length
    const reversedObj = {}
    for (let i = 0; i < length; i++) {
      reversedObj[keys[i]] = values[length - i - 1]
    }
    reversedTokens[key] = reversedObj
  })
  return reversedTokens
}
export const tokensLight = reverseTokens(tokensDark)

// mui theme settings
export const themeSettings = (mode, type) => {
  return {
    palette: {
      mode: mode,
      ...(mode === "dark"
        ? {
            primary: {
              ...tokensDark.secondary,
              main: tokensDark.secondary[300], // main color for dark mode
              light: tokensDark.secondary[50],
            },
            secondary: {
              ...tokensDark.secondary,
              main: tokensDark.secondary[500], // highlight color
            },
            neutral: {
              ...tokensDark.grey,
              main: tokensDark.grey[1000], // grey for neutral elements
            },
            background: {
              default: tokensDark.grey[1000], // black for sidebar
              alt: tokensDark.grey[900], // dark grey
            },
          }
        : {
            primary: {
              ...tokensLight.secondary,
              main: tokensDark.grey[0], // white for light mode
              light: tokensDark.grey[10],
            },
            secondary: {
              ...tokensLight.secondary,
              main: tokensLight.secondary[500],
              light: tokensLight.secondary[100],
            },
            neutral: {
              ...tokensLight.grey,
              main: tokensDark.grey[500],
            },
            background: {
              default: tokensDark.grey[0], // white for light mode
              alt: tokensDark.grey[10], // light grey
            },
          }),
    },
    typography: {
      fontFamily: ["Inter", "sans-serif"].join(","),
      fontSize: 12,
      h1: {
        fontFamily: ["Inter", "sans-serif"].join(","),
        fontSize: 40,
      },
      h2: {
        fontFamily: ["Inter", "sans-serif"].join(","),
        fontSize: 32,
      },
      h3: {
        fontFamily: ["Inter", "sans-serif"].join(","),
        fontSize: 24,
      },
      h4: {
        fontFamily: ["Inter", "sans-serif"].join(","),
        fontSize: 20,
      },
      h5: {
        fontFamily: ["Inter", "sans-serif"].join(","),
        fontSize: 16,
      },
      h6: {
        fontFamily: ["Inter", "sans-serif"].join(","),
        fontSize: 14,
      },
    },
  }
}
